import { lazy } from "react";
// A page part that is loaded on demand (rules, SAP data, assistant …) can
// fail to load in an open tab:
//  - after a new version was deployed: the old file names no longer exist;
//  - after the load balancer's login session ended: the request is
//    redirected to the login.
// Both are fixed by loading the page again. Without this the app showed a
// white page.
const KEY = "einkauf-reloaded-at";
const WINDOW_MS = 30_000;
/** Is the error a failed load of a code part (not an error in the page itself)? */
export function isLoadError(e) {
    const msg = e instanceof Error ? `${e.name} ${e.message}` : String(e);
    return /dynamically imported module|Importing a module script failed|error loading dynamically|Unable to preload|ChunkLoadError|Loading (CSS )?chunk/i.test(msg);
}
/**
 * Reloads the page once; a second failure within 30 s is not reloaded again
 * (no loop), the error view shows instead. Returns whether it reloads.
 */
export function reloadOnce() {
    let last = 0;
    try {
        last = Number(sessionStorage.getItem(KEY) ?? 0);
    }
    catch {
        /* private mode */
    }
    if (Date.now() - last < WINDOW_MS)
        return false;
    try {
        sessionStorage.setItem(KEY, String(Date.now()));
    }
    catch {
        /* private mode */
    }
    window.location.reload();
    return true;
}
/** React.lazy that reloads the page once when the code part cannot be loaded. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- same constraint as React.lazy
export function lazyPage(load) {
    return lazy(() => load().catch((e) => {
        if (isLoadError(e) && reloadOnce())
            return new Promise(() => { });
        throw e;
    }));
}
